import React from "react";
import { Link } from "react-router-dom";
import "./style.scss";

export default function UnAuthorizedPage() {
  return (
    <React.Fragment>
      <div className={"section section-not-found"}>
        <div className={"section-heading"}>
          {/* <h4 className={"section-title"}>NOT FOUND</h4> */}
        </div>
        <div className={"section-body"}>
          <h4>ACCESS DENIED</h4>
          <p>Sorry, you are not allowed to access this page.</p>

          <p>
            You can go back to our
            <Link to="/home" style={{ textDecoration: "none" }}>
              {" "}
              Homepage.
            </Link>
          </p>
          {/* <img src="/assets/images/bg-welcome.png" alt="" /> */}
        </div>
      </div>
    </React.Fragment>
  );
}
